import { render, staticRenderFns } from "./waitDealToDoorServiceArrangement.vue?vue&type=template&id=506f7d6a&scoped=true&"
import script from "./waitDealToDoorServiceArrangement.vue?vue&type=script&lang=js&"
export * from "./waitDealToDoorServiceArrangement.vue?vue&type=script&lang=js&"
import style0 from "./waitDealToDoorServiceArrangement.vue?vue&type=style&index=0&id=506f7d6a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "506f7d6a",
  null
  
)

export default component.exports